import buildDashboardFilterPayload from "./buildDashboardFilterPayload";
import getDetailObj from "./getDetailObj";
export default {
  buildDashboardFilterPayload: buildDashboardFilterPayload,
  getDetailObj: getDetailObj
};